import { Divider, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link, Route } from "react-router-dom";
import config from "../config";
import ContestRankingView from "./ContestRankingView";
import ProblemView from "./ProblemView";
import SolutionView from "./SolutionView";
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton
} from "react-share";
import moment from 'moment/moment'
import 'moment-timezone';

const styles = (theme) => ({
    root: {
        // display: 'flex',
    },
    problem: {
        width: "100%",
    },
    top: {
        textAlign: "center"
    }
});

class ContestView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab_value: "",
            loading: true,
            contest_name: null,
            start_at: null,
            end_at: null,
            has_started: false,
            is_over: false,
        };
    }
    componentDidMount() {
        this.setState({
            tab_value: window.location.pathname.split("/").pop(),
        });
        return fetch(
            config.backend_url + "contests/" + this.props.match.params.contest_id
        ).then((response) => {
            response.json().then((json) => {
                const start_at = moment(json.start_at * 1000);
                const end_at = moment(json.end_at * 1000);
                const now = moment();
                this.setState({ contest_name: json.name, start_at: start_at, end_at: end_at, loading: false, has_started: start_at < now, is_over: end_at < now });
            });
        });
    }

    handleChange = (event, newValue) => {
        this.setState({ tab_value: newValue });
    };

    render() {
        const contest_id = this.props.match.params.contest_id;
        const { classes } = this.props;

        let top;

        if (this.state.loading) {
            top = (<div><p>Loading...</p></div>);
        } else {
            var start = this.state.start_at.tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm");
            var end = this.state.end_at.tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm");
            top = (<Paper>
                <p></p>
                <div className={classes.top}>
                <Typography variant="h4">{this.state.contest_name}</Typography>
                <p>開始 {start}</p>
                <p>終了 {end}</p>
            </div></Paper>);
        }

        let share;
        if (this.state.contest_name) {
            let msg;
            if (this.state.is_over) {
                msg = this.state.contest_name + "に参加しました！ #謎コン"
            } else {
                msg = this.state.contest_name + "に参加します！ #謎コン"
            }
            const url = "https://nazocon.net/contests/" + contest_id + "/"
            share =
                <div align="right">
                    <TwitterShareButton
                        className={styles["post__footer-sns-twitter"]}
                        title={msg}
                        url={url}
                    >
                        <TwitterIcon size={32} round />
                    </TwitterShareButton>
                    <FacebookShareButton
                        className={styles["post__footer-sns-facebook"]}
                        url={url}
                        quote={msg}
                    >
                        <FacebookIcon size={32} round />
                    </FacebookShareButton>
                </div>
        }

        return (
            <div>
                <Paper square>
                    <Tabs
                        value={this.state.tab_value}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        onChange={this.handleChange}
                    >
                        <Tab value="" label="トップ" component={Link} to={"/contests/" + contest_id} />
                        {this.state.has_started ? <Tab value="problems" label="問題" component={Link} to={"/contests/" + contest_id + "/problems"} /> : ""}
                        {this.state.has_started ? <Tab value="ranking" label="順位表" component={Link} to={"/contests/" + contest_id + "/ranking"} /> : ""}
                        {this.state.is_over ? <Tab value="solution" label="解答" component={Link} to={"/contests/" + contest_id + "/solution"} /> : ""}
                    </Tabs>
                </Paper>
                <Divider></Divider>
                <Route
                    path="/contests/:contest_id/ranking"
                    render={() => (
                        <ContestRankingView
                            contest_id={this.props.match.params.contest_id}
                        />
                    )}
                />
                <Route
                    path="/contests/:contest_id/solution"
                    render={() => (
                        <SolutionView contest_id={this.props.match.params.contest_id} />
                    )}
                />
                <Route
                    exact path="/contests/:contest_id/problems"
                    render={() => (
                        <ProblemView contest_id={this.props.match.params.contest_id} user_id={this.props.user_id} />
                    )}
                />
                <Route
                    exact path="/contests/:contest_id/"
                >
                    {top}
                </Route>
                {share}
            </div>
        );
    }
}

ContestView.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            contest_id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    user_id: PropTypes.string,
};

export default withStyles(styles)(ContestView);
